import React from "react";
import {
  FiPackage,
  FiUserCheck,
  FiDollarSign,
  FiActivity,
  FiTruck,
  FiMapPin
} from "react-icons/fi";
import { useCheckoutStore } from "../../store/checkoutStore";
import ShippingMethodCard from "./ShippingMethodCard";

export default function ShipmentCard({ shipment, onSelectMethod }) {
  const destinationAddress = useCheckoutStore((state) => state.destinationAddress);

  // بررسی روش ارسال انتخاب شده فعلی
  const selectedOptionId = shipment.selected_option?.id;

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-200 mb-6 overflow-hidden transition-all">
      {/* هدر محموله - ریسپانسیو شده */}
      <div className="bg-gray-50/80 p-4 sm:p-5 border-b border-gray-100">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div>
            <div className="flex items-center gap-2 mb-2">
              <span className="p-1.5 bg-[#1E3A5F]/10 text-[#1E3A5F] rounded-lg">
                <FiTruck size={18} />
              </span>
              <h2 className="text-base font-bold text-gray-800">
                محموله ارسالی {shipment.uuid.substring(0, 8)}...
              </h2>
            </div>

            {/* اطلاعات متای محموله با چیدمان فلکس ریسپانسیو */}
            <div className="flex flex-wrap gap-x-6 gap-y-2 text-xs sm:text-sm text-gray-600">
              <span className="flex items-center gap-1.5">
                <FiUserCheck className="text-gray-400" size={16} />
                <span className="font-medium text-gray-500">تأمین‌کننده:</span>
                <span className="text-gray-900">{shipment.supplier.name}</span>
              </span>
              <span className="flex items-center gap-1.5">
                <FiMapPin className="text-gray-400" size={16} />
                <span className="font-medium text-gray-500">مبدأ:</span>
                <span className="text-gray-900">{shipment.origin_address.title}</span>
              </span>
            </div>
          </div>

          {/* خلاصه‌ی وضعیت عددی در هدر */}
          <div className="flex items-center gap-3 bg-white p-2 rounded-xl border border-gray-100 shadow-sm self-start md:self-center">
            <div className="px-3 border-l border-gray-100 text-center">
              <p className="text-[10px] text-gray-400 mb-0.5">وزن کل</p>
              <p className="text-sm font-bold text-[#00AFA9] leading-none">
                {shipment.total_weight_calculated} <span className="text-[10px] font-normal">کیلوگرم</span>
              </p>
            </div>
            <div className="px-3 text-center">
              <p className="text-[10px] text-gray-400 mb-0.5">ارزش کالا</p>
              <p className="text-sm font-bold text-[#1E3A5F] leading-none">
                {Number(shipment.total_price_without_discount).toLocaleString('fa-IR')} <span className="text-[10px] font-normal">تومان</span>
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* لیست اقلام محموله */}
      <div className="p-4 sm:p-5 space-y-4">
        {shipment.items.map((item) => (
          <div
            key={item.product_id}
            className="flex items-start sm:items-center gap-4 p-3 hover:bg-gray-50/50 rounded-xl border border-transparent hover:border-gray-100 transition-all group"
          >
            <div className="relative overflow-hidden rounded-lg border border-gray-200 bg-gray-50 shrink-0 shadow-sm">
              <img
                src={item.featured_image_url}
                alt={item.name}
                className="w-16 h-16 sm:w-20 sm:h-20 object-cover group-hover:scale-105 transition-transform duration-300"
              />
            </div>

            <div className="flex-1 min-w-0">
              <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-1">
                <div>
                  <h3 className="font-semibold text-gray-800 text-sm sm:text-base truncate">
                    {item.name}
                  </h3>
                  <p className="text-[11px] text-gray-400 mt-0.5">{item.category}</p>
                </div>

                <div className="flex items-center gap-2 mt-2 sm:mt-0">
                   <span className="inline-flex items-center rounded-full bg-gray-100 px-2 py-0.5 text-[11px] font-medium text-gray-600">
                    {item.quantity} {item.unit_of_measure === "area" ? "متر مربع" : "عدد"}
                  </span>
                  <span className="text-xs font-bold text-gray-500 bg-gray-50 px-2 py-0.5 rounded-full border border-gray-100">
                    {item.weight}kg
                  </span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* بخش انتخاب روش ارسال */}
      <div className="p-4 sm:p-5 bg-[#1E3A5F]/[0.02] border-t border-gray-100">
        <div className="flex items-center gap-2 mb-4">
          <div className="w-1 h-4 bg-[#00AFA9] rounded-full"></div>
          <h4 className="text-sm font-bold text-gray-800">
            انتخاب روش ارسال برای این محموله:
          </h4>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {shipment.options.map((method) => {
            const isSelected = selectedOptionId === method.id;

            // نیاز به آدرس مقصد برای روش‌های ارسال خاص
            const addressRequired =
              method.method === "carrier" || method.method === "supplier";

            const disabled = addressRequired && !destinationAddress;

            return (
                method.estimated_delivery_date && (
                  <ShippingMethodCard
                    key={method.id}
                    method={method}
                    isSelected={isSelected}
                    disabled={disabled}
                    onClick={() => onSelectMethod(shipment.id, method.id)}
                  />
                )
            );
          })}
        </div>

        {!destinationAddress && (
            <p className="mt-3 text-[11px] text-[#E74C3C] flex items-center gap-1">
                <FiActivity size={12} />
                لطفاً برای مشاهده تمام روش‌های ارسال، ابتدا آدرس مقصد را انتخاب کنید.
            </p>
        )}
      </div>
    </div>
  );
}
